// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1Iln_","messages":"Chat_messages__3Jhwv","dateDivider":"Chat_dateDivider__jUFDQ"};